import { ActionType } from "../action-types/index";
import { Action } from "../actions";

export interface ReduxState {
  langValue: string;
  formData: any;
  freezScreen: boolean;
  alert: any;
  shopUrl: any;
  userInfo: any;
  tableList: any;
  tableInvoice: any;
  invoiceData: any;
  branch: any,
  token: any;
  loggedIn: boolean;
  tablesType: any
  tableInfo:any
  stateUrlToken:string
  customTableSearchMode:boolean,
  invoiceMarkedpopup:boolean
}

const initialState = {
  notes: [],
  langValue: "en",
  formData: [],
  freezScreen: false,
  alert: {
    show: false,
    message: "",
  },
  shopUrl: "",
  userInfo: {},
  tableList: [],
  tableInvoice: [],
  invoiceData: [],
  branch: [],
  token: "",
  loggedIn: false,
  tablesType: {}, 
  tableInfo: {},
  stateUrlToken:"",
  customTableSearchMode:false,
  invoiceMarkedpopup:false
};

const waiter = (state: ReduxState = initialState, action: Action) => {
  switch (action.type) {
    case ActionType.SET_LANG_VALUE:
      return { ...state, langValue: action.payload };
    case ActionType.SET_FREEZ_SCREEN:
      return { ...state, freezScreen: action.payload };
    case ActionType.SET_FORMDATA:
      return { ...state, formData: action.payload };
    case ActionType.SET_ALERT_MESSAGE:
      return { ...state, alert: action.payload };
    case ActionType.SET_SHOP_URL:
      return { ...state, shopUrl: action.payload };
    case ActionType.SET_USER_INFO:
      return { ...state, userInfo: action.payload };
    case ActionType.SET_TABLE_LIST:
      return { ...state, tableList: action.payload };
    case ActionType.SET_TABLE_INVOICE:
      return { ...state, tableInvoice: action.payload };
    case ActionType.SET_INVOICE_DATA:
      return { ...state, invoiceData: action.payload };
    case ActionType.SET_BRANCH_DATA:
      return { ...state, branch: action.payload };
    case ActionType.SET_LOGIN:
      return { ...state, token: action.payload, stateUrlToken:action.stateUrlToken };
    case ActionType.SET_TABLES_TYPE:
      return { ...state, tablesType: action.payload };
    case ActionType.SET_TABLE_INFO:
      return { ...state, tableInfo: action.payload };
      case ActionType.SET_CUSTOM_TABLE_SEARCH_MODE:
      return { ...state, customTableSearchMode: action.payload };
      case ActionType.SET_InvoiceMarkedpopup:
        return { ...state, invoiceMarkedpopup: action.payload };

    case ActionType.SET_LOGOUT:
      return initialState;
    default:
      return state;
  }
};
export default waiter;
